module.exports = __webpack_public_path__ + "static/media/versace_hero.2f23ea0d.png";